import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'
import { Scanner } from '@yudiel/react-qr-scanner'
import { toast } from 'react-toastify'

// Mahsulot qabul qilish sahifasidagi kamera skaneri.
// Tugma + modal bir joyda, chaqiruvchi sahifa faqat `onScan` ni beradi.
const BARCODE_FORMATS = ['code_128', 'code_39', 'ean_13', 'ean_8', 'upc_a', 'upc_e', 'itf', 'data_matrix', 'aztec']

// Mobil qurilmani aniqlash -- boshqa sahifalardagi skaner bilan bir xil shart.
function checkMobile() {
	return window.innerWidth <= 768 ||
		/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

function BarcodeScannerButton({ onScan, disabled = false, className = '' }) {
	const { t } = useTranslation()

	const [isMobile, setIsMobile] = useState(checkMobile)
	const [modalScanner, setModalScanner] = useState(false)
	const [scannerZoom, setScannerZoom] = useState(1)

	useEffect(() => {
		const onResize = () => setIsMobile(checkMobile())
		window.addEventListener('resize', onResize)
		return () => window.removeEventListener('resize', onResize)
	}, [])

	function closeScanner() {
		setModalScanner(false)
		setScannerZoom(1)
	}

	// Faqat telefon versiyasida ko'rinadi.
	if (!isMobile) return null

	return (
		<>
			<div
				className={className}
				style={{
					width: '45px',
					height: '45px',
					borderRadius: '8px',
					flexShrink: 0,
					backgroundColor: disabled ? '#a6d9c5' : '#25B17B',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					cursor: disabled ? 'not-allowed' : 'pointer'
				}}
				onClick={() => { if (!disabled) setModalScanner(true) }}>
				<i className="uil uil-capture" style={{ color: '#fff', fontSize: '22px' }}></i>
			</div>

			<Modal show={modalScanner} animation={false} centered onHide={closeScanner}>
				<Modal.Header closeButton>
					<Modal.Title>{t('SCAN_BARCODE')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div style={{ width: '100%', height: '300px', overflow: 'hidden', position: 'relative' }}>
						<div style={{ width: '100%', height: '100%', transform: `scale(${scannerZoom})`, transformOrigin: 'center center' }}>
							{modalScanner &&
								<Scanner
									onScan={(result) => {
										if (result && result.length > 0) {
											closeScanner()
											onScan(result[0].rawValue)
											toast.success(t('SCANNED_SUCCESSFULLY'))
										}
									}}
									onError={(error) => console.log(error?.message)}
									formats={BARCODE_FORMATS}
									scanDelay={0}
									constraints={{ facingMode: 'environment' }}
									styles={{
										container: { width: '100%', height: '100%' },
										video: { width: '100%', height: '100%', objectFit: 'cover' }
									}}
								/>
							}
						</div>
					</div>

					{/* Zoom */}
					<div className="d-flex justify-content-center align-items-center gap-3 mt-3">
						<button
							type="button"
							className="btn btn-outline-secondary"
							style={{ width: '50px', height: '50px', fontSize: '24px', borderRadius: '50%' }}
							onClick={() => setScannerZoom(prev => Math.max(1, prev - 0.5))}
							disabled={scannerZoom <= 1}
						>
							<i className="uil uil-minus"></i>
						</button>
						<span style={{ minWidth: '60px', textAlign: 'center', fontSize: '18px', fontWeight: 'bold' }}>{scannerZoom}x</span>
						<button
							type="button"
							className="btn btn-outline-secondary"
							style={{ width: '50px', height: '50px', fontSize: '24px', borderRadius: '50%' }}
							onClick={() => setScannerZoom(prev => Math.min(4, prev + 0.5))}
							disabled={scannerZoom >= 4}
						>
							<i className="uil uil-plus"></i>
						</button>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button type="button" className="btn btn-warning w-100" onClick={closeScanner}>
						{t('CANCEL')}
					</button>
				</Modal.Footer>
			</Modal>
		</>
	)
}

export default BarcodeScannerButton
